 import React, { useEffect, useRef, useState } from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import PlatformKeyFeaturesCard1 from "./PlatformKeyFeaturesCard1";
const  PlatformKeyFeaturesCardIndexPage = ({ setCurrentContentIndex,currentIndex,CurrentObject ,setCurrentObject, setHideReduUnDo, moveItemUp,moveItemDown,deleteItem,duplicateItem,duplicateContentsItem,item ,dynamicId,
    
}) =>{   const dispatch = useDispatch();
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
    const [reloadItems, setReloadItems] = useState(true);

    useEffect(()=>{
        setReloadItems(false); setReloadItems(true)
    },[ currentIndex]
)
    const extractElementType = (str) => {
  const match = str?.match(/^.*?-(.*?)-.*$/);
  return match ? match[1] : null;
};

return(<>

 {
  extractElementType(item?.myKey)=="PlatformKeyFeaturesCard1"? <>
  
  <PlatformKeyFeaturesCard1  setCurrentContentIndex={(currentContentIndex)=>{setCurrentContentIndex(currentContentIndex);
      // alert(currentContentIndex)
    }}
        CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={dynamicId} 
             setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
              // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
           
          moveItemUp={(item)=>{moveItemUp(item);setHideReduUnDo(true)}} moveItemDown={(item)=>{moveItemDown(item);setHideReduUnDo(true)}} 
      deleteItem={(item)=>{deleteItem(item);setHideReduUnDo(true)}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}  duplicateItem={(item)=>{duplicateItem(item);setHideReduUnDo(true)}} 
      
      item={item}
           
      />
     
      
      
     </> :""}{
  extractElementType(item?.myKey)=="PlatformKeyFeaturesCard2"? <>
   
  <PlatformKeyFeaturesCard1  setCurrentContentIndex={(currentContentIndex)=>{setCurrentContentIndex(currentContentIndex);
      // alert(currentContentIndex)
    }}
        CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={dynamicId} 
             setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
              // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
           
          moveItemUp={(item)=>{moveItemUp(item);setHideReduUnDo(true)}} moveItemDown={(item)=>{moveItemDown(item);setHideReduUnDo(true)}} 
      deleteItem={(item)=>{deleteItem(item);setHideReduUnDo(true)}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}  duplicateItem={(item)=>{duplicateItem(item);setHideReduUnDo(true)}} 
      
      item={item}
           
      />
     
      
      
     </> :""}
  

</>)
}
export default PlatformKeyFeaturesCardIndexPage;